import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function AIChatPage() {
  return (
    <SectionLayout title="AI Chat">
      {/* AI chat content will go here */}
    </SectionLayout>
  );
}

